import { useContext } from "react";
import { AuthContext } from "../Contexts/AuthContext";

export const useAuthContext = () => {
  const {state: user, dispatch} = useContext(AuthContext);
  
  return {user,dispatch};
  
}
